<section *ngIf="isVisible$ | async" class="loader-container">
    <mat-progress-spinner mode="indeterminate" [diameter]="35"></mat-progress-spinner>
</section>
